<template>
  <div v-if="is_load">
    <div class="justify-end ml-0 mr-0 mb-3">
      <p class="mt-4 mb-0 float-left">
        [검색결과 <font class="primary--text">{{ ordersCount | comma }}</font
        >명]
      </p>
    </div>
    <div class="row justify-end ml-0 mr-0 mb-3">
      <v-select
        v-model="viewListCount"
        :items="viewListCountItem"
        label="50개씩 보기"
        persistent-hint
        single-line
        outlined
        dense
        class="pa-0"
        style="max-width:150px; font-size:14px;"
        hide-details
        @change="viewListCountChange()"
      ></v-select>
    </div>

    <v-card class="manageCodeList col-12 mb-4 pb-0">
      <div class="row justify-end mt-0 mb-0">
        <div class="row justify-start mt-0 mb-0" style="padding-left: 25px;">
          <v-btn
            small
            color="grey darken-4"
            class="white--text"
            @click="membershipClose()"
            >멤버십 해지</v-btn
          >
          <div class="float-left align-center d-flex">
            <template>
              <div class="text-center float-left">
                <div style="display: flex;">
                  <v-tooltip
                    v-model="membership_close_tooltip"
                    right
                    content-class="membership_close_tooltip"
                  >
                    <template v-slot:activator="{ attrs }">
                      <v-icon
                        v-bind="attrs"
                        class="ml-2"
                        @click="
                          membership_close_tooltip = !membership_close_tooltip
                        "
                        color="#8C8C8C"
                        >mdi-alert-circle</v-icon
                      >
                    </template>
                    <div>
                      <p class="text-left ma-3">
                        ※ 멤버십 해지시 변경 사항<br />
                        1. 이전 회원 등급으로 자동 변경되어 관련 혜택을 받을 수
                        없게 됩니다.<br />
                        2. 쿠폰 및 적립금 회수 설정을 한 경우 미사용된 쿠폰,
                        적립금을 회수 처리합니다.<br />
                        <br />
                        ※ 멤버십 해지시 환불 관련 사항<br />
                        1. 고객이 멤버십 구매 후 주문등 혜택을 받지 않은 경우
                        해지와 함께 자동 환불처리됩니다.<br />
                        PG결제(카드결제, 계좌이체)만 해당됩니다. 휴대폰결제등
                        기타 결제는 관리자가 직접 환불해주세요.<br />
                        2. 고객이 멤버십 구매 후 주문등 혜택을 받은 경우 자동
                        환불처리되지 않습니다.<br />
                        운영 정책에 따라 주문상세정보 팝업에서 확인 후 환불
                        처리하는 것을 권장합니다.<br />
                      </p>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </div>
        </div>

        <v-btn
          small
          color="green"
          class="white--text ml-3 mr-3"
          @click.prevent="excelDownload"
          >엑셀 다운로드</v-btn
        >
      </div>

      <v-data-table
        v-model="selectModel"
        :headers="headers"
        :items="order_items"
        calculate-widths
        item-key="order_id"
        scrollable
        class="pl-1 pr-1 memberMansgeTable"
        hide-default-footer
        show-select
        :items-per-page="viewListCount"
        mobile-breakpoint="0"
      >
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
          class="checkbox-custom"
        >
          <v-simple-checkbox
            v-if="item.member_membership_status == 'enabled'"
            :value="isSelected"
            @input="select($event)"
            :ripple="false"
            class="checkbox-custom"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.paid_at`]="{ item }">
          <p
            class="mt-3 text-center caption"
            v-html="$options.filters.defaultDate(item.paid_at)"
          ></p>
        </template>

        <template v-slot:[`item.order_id`]="{ item }">
          <div
            v-if="freeOrderIdCheck(item.order_id) === false"
            class="hover"
            @click="orderDetailPageMove(item.order_id)"
          >
            <p class="mt-3  text-center caption primary--text hover">
              {{ item.order_id }}
            </p>
          </div>
          <div v-else class="">
            <p class="mt-3 text-center caption">
              {{ item.order_id }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.member_name`]="{ item }">
          <div class="primary--text hover">
            <p
              class="mt-3 mb-0 text-center caption primary--text hover"
              @click="cafe24UserPageMove(item.member_id)"
            >
              {{ item.member_name }}
            </p>
            <p
              class="mt-0 text-center caption primary--text hover"
              @click="cafe24UserPageMove(item.member_id)"
            >
              {{ item.member_id }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.membership_name`]="{ item }">
          <div>
            <p class="mt-3  text-center caption">
              {{ item.membership_name }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.order_price_amount`]="{ item }">
          <div>
            <p class="mt-3  text-center caption">
              {{ item.order_price_amount | comma }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.actual_payment_amount`]="{ item }">
          <div>
            <p class="mt-3  text-center caption">
              {{ item.actual_payment_amount | comma }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.use_discount`]="{ item }">
          <div>
            <p class="mt-3  text-center caption">
              {{ item.use_discount | memberDiscountConversion }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.started_at`]="{ item }">
          <div>
            <p class="mt-3  text-center caption">
              {{ item.started_at }} ~
              {{ getExpirationText(item.expired_at) }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.member_membership_status`]="{ item }">
          <div>
            <p
              class="mt-3  text-center caption"
              v-html="membershipStatusText(item)"
            ></p>
          </div>
        </template>

        <template slot="no-data">
          <div class="noDataProductInfos">내역이 없습니다.</div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="items.length > 0" class="text-center">
      <v-container class="pa-0">
        <v-row justify="center">
          <v-col cols="4" class="pa-0">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                :length="pageCount"
                @input="onPageChange"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
.manageCodeList a:hover {
  text-decoration: underline;
}
.disabledBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.4444444444px;
  font-size: 0.75rem;
  background-color: #f5f5f5;
  color: #bababa;
}

.v-data-table.memberMansgeTable td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 8px;
  padding-right: 8px;
}

.memberMansgeTable.theme--light.v-data-table thead tr:last-child th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  padding-left: 8px;
  padding-right: 8px;
}
/*
style="text-decoration: underline; text-decoration-color : #1976d2;"
*/
.memberMansgeTable .underline :hover {
  cursor: pointer;
  text-decoration: underline;
}

.memberMansgeTable .memberInfo .hover :hover {
  cursor: pointer;
  text-decoration: underline;
}
.memberInfoHover {
  cursor: pointer;
}
.memberInfoHover :hover {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #1976d2;
}
.membership_close_tooltip {
  position: absolute;
  top: 754px !important;
}
</style>
<script>
//import Vue from "vue";
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/membership/filters.js";
import Excel from "@/libs/excel.js";
const ProgressDialog = () =>
  import(
    /* webpackChunkName: "ProgressDialog" */ "@/components/membership/membership_manage/modal/ProgressDialog.vue"
  );
export default {
  data() {
    return {
      M,
      selectModel: [],
      headers: [
        {
          text: "결제일시",
          align: "center",
          sortable: false,
          value: "paid_at",
          width: 90,
          filterable: false,
        },
        {
          text: "주문번호",
          align: "center",
          value: "order_id",
          sortable: false,
          width: 150,
          filterable: false,
        },
        {
          text: "주문자명",
          align: "center",
          value: "member_name",
          sortable: false,
          width: 100,
          filterable: false,
        },
        {
          text: "멤버십명",
          align: "center",
          value: "membership_name",
          sortable: false,
          width: 150,
          filterable: false,
        },
        {
          text: "판매금액",
          align: "center",
          value: "order_price_amount",
          sortable: false,
          width: 130,
        },
        {
          text: "실결제금액",
          align: "center",
          value: "actual_payment_amount",
          sortable: false,
          width: 70,
          filterable: false,
        },
        {
          text: "결제방법",
          align: "center",
          value: "use_discount",
          sortable: false,
          width: 100,
          filterable: false,
        },
        {
          text: "멤버십기간",
          align: "center",
          value: "started_at",
          sortable: false,
          width: 150,
          filterable: false,
        },
        {
          text: "멤버십상태",
          align: "center",
          value: "member_membership_status",
          sortable: false,
          width: 100,
          filterable: false,
        },
      ],
      items: [],
      page: 1,
      pageCount: 0,
      viewListCount: 50,
      viewListCountItem: [
        { text: "50개씩 보기", value: 50 },
        { text: "70개씩 보기", value: 70 },
        { text: "100개씩 보기", value: 100 },
      ],
      ordersCount: 0,
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          paid_at: "결제일시",
          order_id: "주문번호",
          member_id: "주문자id",
          member_name: "주문자명",
          membership_name: "멤버십명",
          order_price_amount: "판매금액",
          actual_payment_amount: "실결제금액",
          use_discount: "결제방법",
          started_at: "멤버십 기간 시작일",
          expired_at: "멤버십 기간 종료일",
          member_membership_status: "멤버십 상태",
        },
      },
      is_load: false,
      membership_close_tooltip: false,
    };
  },
  methods: {
    getExpirationText(expiredAt) {
      const currentDate = new Date("2024-08-02");
      const expirationDate = new Date(expiredAt);

      if (expirationDate >= currentDate) {
        return "무제한";
      } else {
        return expiredAt;
      }
    },
    cafe24UserPageMove: function(user_id) {
      window.open(
        `https://${this.$store.state.mallId}.cafe24.com/admin/php/c/member_admin_d_f.php?mode=2&user_id=` +
          user_id,
        "_blank"
      );
    },
    membershipClose: async function() {
      let membershipCloseResult = true;

      if (this.selectModel.length < 1) {
        alert("체크박스를 선택해 주세요.");
        return false;
      }

      if (
        confirm(
          "선택된 주문건 회원의\n멤버십을 해지하시겠습니까?\n\n멤버십 구매후 주문 할인/적립등의 멤버십 할인 혜택을 \n받지 않은 경우 전액 환불처리됩니다."
        )
      ) {
        let is_use_discount = "F";
        this.$refs.ProgressDialog.show();
        for (let i = 0; i < this.selectModel.length; i++) {
          if (this.selectModel[i].use_discount == "T") {
            is_use_discount = "T";
          }
          try {
            await M.api(
              M.entry("/del/membership/orders", this.selectModel[i].order_id)
            );
          } catch (e) {
            console.log(e);
            membershipCloseResult = false;
          }
        }

        this.selectModel = [];
        if (membershipCloseResult == false) {
          alert(
            "쇼핑몰 데이터 조회시\n회원이 직접 쇼핑몰 해지 또는 탈퇴 회원의 주문건으로 확인됩니다.\n확인을 클릭하시면 정상적으로 주문목록에 해지 처리를 반영합니다."
          );
        } else {
          if (is_use_discount == "T") {
            alert(
              "해지가 완료되었습니다.\n\n해지 고객이 주문등 멤버십 혜택을 받은 경우 \n환불처리 및 주문상태(반품완료/환불완료) 변경이 되지 않습니다.\n주문번호를 클릭하여 주문건을 확인하는 것을 권장합니다."
            );
          } else {
            alert(
              "해지가 완료되었습니다.\n\n해지 고객이 주문등 멤버십 혜택을 받은 경우 \n환불처리 및 주문상태(반품완료/환불완료) 변경이 되지 않습니다.\n주문번호를 클릭하여 주문건을 확인하는 것을 권장합니다."
            );
          }
        }
        this.$parent.$refs.OrderSearch.execSearch();
        this.$refs.ProgressDialog.hide();
      }
    },
    orderDetailPageMove: function(order_id) {
      window.open(
        `https://${this.$store.state.mallId}.cafe24.com/admin/php/s_new/order_detail.php?order_id=` +
          order_id +
          "&menu_no=74",
        "_blank"
      );
    },
    setOrderList: function(params) {
      this.items = params.list;
      this.ordersCount = params.count;
      this.$parent.serchShow();
    },
    // 엑셀 다운로드
    excelDownload: async function() {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      this.excelData.sheetData = [];
      this.excelData.totalCount = this.ordersCount;

      if (this.items.length === 0) {
        alert("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }

      if (this.excelData.totalCount > this.excelData.totalLimit) {
        alert(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건\n이내로 검색하여 다운로드 해주세요."
        );
        return false;
      }

      // 엑셀 시작
      this.initExcelDownload();
    },

    /**
     * 엑셀 시작
     */
    initExcelDownload: function() {
      this.$refs.ProgressDialog.show();
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        //await this.excelData.Excel.addSheet([]);
      }
      await this.getExcelDataAdd();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      if (this.excelData.offset >= this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }

      let excelPayload = this.$parent.$refs.OrderSearch.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;

      let search_order = await M.api(
        M.entry("/get/membership/orders"),
        excelPayload
      );

      if (search_order.length === 0) {
        await this.endExcel();
        return false;
      }

      let excel_items = search_order.list;

      this.excelData.offset = this.excelData.offset + this.excelData.limit;

      for (let i = 0; i < excel_items.length; i++) {
        let use_discount = excel_items[i].use_discount;
        let member_membership_status = excel_items[i].member_membership_status;
        if (use_discount == "F") {
          excel_items[i].use_discount = "1회결제";
        } else {
          excel_items[i].use_discount = "정기결제";
        }

        if (member_membership_status == "enabled") {
          excel_items[i].member_membership_status = "가입중";
        } else if (member_membership_status == "disabled") {
          excel_items[i].member_membership_status = "만료";
          if (excel_items[i].canceled_by == "membership") {
            excel_items[i].member_membership_status = "해지 (멤버십 연장)";
          }
          if (excel_items[i].canceled_by == "admin") {
            excel_items[i].member_membership_status = "해지 (관리자 해지)";
          }
          if (excel_items[i].canceled_by == "member") {
            excel_items[i].member_membership_status = "해지 (구매자 해지)";
          }
        } else if (member_membership_status == "unsubscribe") {
          excel_items[i].member_membership_status = "가입중 (해지 예정)";
        } else {
          let canceled_by = "해지";
          if (excel_items[i].canceled_by == "admin") {
            canceled_by = "해지 (관리자 해지)";
          }
          if (excel_items[i].canceled_by == "member") {
            canceled_by = "해지 (구매자 해지)";
          }
          if (excel_items[i].canceled_by == "membership") {
            canceled_by = "해지 (멤버십 연장)";
          }
          excel_items[i].member_membership_status = canceled_by;
        }
      }

      if (excel_items.length > 0) {
        this.excelData.sheetData = excel_items;
        this.excelData.Excel.addSheet(this.excelData.sheetData);
        this.addExcel();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.$refs.ProgressDialog.hide();
      }, 1500);
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}_order`
      );
    },

    onPageChange: async function() {
      this.items = [];
      this.tableLoading = true;
      this.$parent.$refs.OrderSearch.setSearchPayload(
        this.viewListCount,
        this.page
      );
    },
    viewListCountChange: function() {
      this.page = 1;
      this.$parent.$refs.OrderSearch.setSearchPayload(
        this.viewListCount,
        this.page
      );
    },

    freeOrderIdCheck: function(order_id) {
      if (order_id.indexOf("FREE") >= 0) {
        return true;
      } else {
        return false;
      }
    },
    membershipStatusText: function(parmas) {
      let str = "";
      let status = parmas.member_membership_status;
      let cancel_by = parmas.canceled_by;

      if (status == "enabled") {
        str = "가입중";
      } else if (status == "disabled") {
        str = "만료";
        if (cancel_by && cancel_by == "membership") {
          str = "해지<br>(멤버십 연장)";
        }
        if (cancel_by && cancel_by == "admin") {
          str = "해지<br>(관리자 해지)";
        }
        if (cancel_by && cancel_by == "member") {
          str = "해지<br>(구매자 해지)";
        }
      } else if (status == "unsubscribe") {
        str = "가입중<br>(해지 예정)";
      } else {
        str = "해지";

        if (cancel_by == "admin") {
          str += "<br>(관리자 해지)";
        } else if (cancel_by == "member") {
          str += "<br>(구매자 해지)";
        } else if (cancel_by == "membership") {
          str += "<br>(멤버십 연장)";
        } else {
          str += "";
        }
      }

      return `${str}`;
    },
  },
  computed: {
    order_items() {
      return this.items.map((x) => ({
        ...x,
        isSelectable: x.member_membership_status == "enabled",
      }));
    },
  },
  components: {
    ProgressDialog,
  },
  mixins: [CommonMixin],
  filters: Filters,
};
</script>
